var AddIconSvg = "data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%2211%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10%206.204H5.704V10.5H4.296V6.204H0V4.796h4.296V.5h1.408v4.296H10v1.408Z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E";

export { AddIconSvg as default };
//# sourceMappingURL=add-icon.svg.js.map
